import React from 'react'
import parse from 'html-react-parser'
import { ProductAttribute } from './ProductHeader.partials'
import { ProductHeaderProps } from './ProductHeader.types'

const ProductHeader = ({
  attributes,
  attrMaxValue,
  category,
  classification,
  emptyIcon,
  filledIcon,
  longDescription,
  name,
  seals,
  shortDescription,
  styling = {
    container: '',
    wrapper: '',
    sealsContainer: '',
    preline: '',
    productName: '',
    shortDescription: '',
    longDescription: '',
    category: '',
    attributeIcons: '',
    attributeKeyClasses: '',
    tag: ''
  },
  promotionTag
}: ProductHeaderProps) => {
  const MAX_SEALS = 3

  return (
    <div className={styling.container}>
      <div className={styling.wrapper}>
        <div className={styling.sealsContainer}>
          {seals &&
            seals?.length > 0 &&
            seals.slice(0, MAX_SEALS).map((sealIcon, idx) => (
              <span key={idx} className='mr-2 last:m-0 md:mb-2 md:mr-0'>
                {sealIcon}
              </span>
            ))}
        </div>
        {promotionTag && <div className={styling.tag}>{promotionTag}</div>}
        {category && category}
        {classification && (
          <div className={styling.preline}>{classification}</div>
        )}
        <h1 className={styling.productName}>{name}</h1>
        {shortDescription && (
          <div className={styling.shortDescription}>
            {parse(shortDescription)}
          </div>
        )}
        {longDescription && (
          <div className={styling.longDescription}>
            {parse(longDescription)}
          </div>
        )}
        {attributes?.length > 0 &&
          attributes.map((attr, idx) => (
            <ProductAttribute
              key={idx}
              emptyIcon={emptyIcon}
              filledIcon={filledIcon}
              name={attr.name}
              value={attr.value}
              maxValue={attrMaxValue}
              className={styling.attributeIcons}
              attributeKeyClasses={styling.attributeKeyClasses}
            />
          ))}
      </div>
    </div>
  )
}

export default ProductHeader
